import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import getters from './getters'
import tagsView from './modules/tagsView'
import audit from './modules/audit'
import merchant from './modules/merchant'
import createPersistedState from 'vuex-persistedstate'
import decorate from './decorate/decorate'
import setting from './decorate/setting'
import config from './decorate/config'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    tagsView,
    audit,
    merchant,
    decorate,
    setting,
    config
  },
  getters,
  plugins: [createPersistedState()]
})

export default store
